import './src/vaadin-chart.js';
export * from './src/vaadin-chart.js';
